/* eslint-disable @typescript-eslint/no-empty-function */
import { CUSTOM_PCKAGEID, REDEEMABLES_TYPES } from "@constant/common";
import { CIRCULAR_GRID, HORIZONTAL_SQUARE, LARGE_BANNER, SAMLL_BANNER, SQUARE_BANNER, SQUARE_GRID } from "@constant/layout";
import { BANNER_NO_IMAGE, LARGE_SLIDER_NO_IMAGE, SMALL_SLIDER_NO_IMAGE, SUB_CAT_NO_IMAGE } from '@constant/noImage';
import { PRODUCT, SERVICE } from '@constant/types';
import { CAT_HOMEPAGE } from "@constant/userSearchSource";
import ImageSlider from "@element/imageSlider";
import CircularGrid from "@module/circularGrid";
import HorizontalSquareGrid from '@module/horizontalSquareGrid';
import ProductsWithCategory from '@module/productsWithCategory';
import RedeemablesListView from "@module/reedemablesListView";
import SquareGrid from "@module/squareGrid";
import UserRegistrationModal from "@module/userRegistration";
import { getStoreGiftCardData, getStoreMembershipData, getStorePackageData } from "@storeData/store";
import { getUserByGuestId } from "@storeData/user";
import { prepareStoreData } from "@util/dataFilterService";
import { navigateTo } from '@util/routerService';
import { getGenericImages, hex2rgb, removeObjRef } from '@util/utils';
import { windowRef } from '@util/window';
import { showSuccess, updateGenericImages, updateGroupStatus, updateGuestMemberships, updateGuestPackages, updateRedeemablesList, updateStoreData } from "app/redux/actions";
import React, { useEffect, useState } from 'react';
import { useCookies } from "react-cookie";
import { connect, useDispatch, useSelector } from 'react-redux';

function HomePage({ storeData, activeGroup, storeMetaData }) {
  const [cookie, setCookie] = useCookies(['grp'])
  const dispatch = useDispatch();
  let availableGroups = storeData?.configData?.genderConfig || '';
  availableGroups = availableGroups.split(',');
  const configData = useSelector((state: any) => state.store?.storeData?.configData);
  const keywords = useSelector((state: any) => state.store?.storeData?.keywords);
  const currentPage = useSelector((state: any) => state.currentPage);
  const baseRouteUrl = useSelector((state: any) => state.store.baseRouteUrl);
  const cartAppointment = useSelector((state: any) => state.appointmentServices);
  const redeemablesList = useSelector((state: any) => state.redeemablesList);
  const [isAnyProductAvailable, setIsAnyProductAvailable] = useState(false)
  const [isAnyServiceAvailable, setIsAnyServiceAvailable] = useState(false)
  const [whatsappLinkData, setWhatsappLinkData] = useState(null);
  const store = useSelector((state: any) => state);
  const languageData: any = store.languageKeywords
  const activeLanguage: any = store.activeLanguage
  const [dataCookie, setDataCookie] = useCookies();
  const [userData, setUserData] = useState(dataCookie['user']);
  const [showUserRegistrationModal, setShowUserRegistrationModal] = useState(false)

  const onClickCategory = (cat) => {
    // console.log(cat)
  }
  const membershipDisplay = Boolean(configData?.storeConfig?.sparkConfig?.purchaseConfig?.membershipDisplay)
  const packageDisplay = Boolean(configData?.storeConfig?.sparkConfig?.purchaseConfig?.packageDisplay)
  const giftCardDisplay = Boolean(configData?.storeConfig?.sparkConfig?.purchaseConfig?.giftCardDisplay)

  const [smallBanners, setSmallBanners] = useState<any>();
  useEffect(() => {
    windowRef && document.body.classList.remove("o-h")
  }, [windowRef])

  useEffect(() => {
    setUserData(dataCookie?.user || null);
  }, [dataCookie?.user])

  useEffect(() => {
    if (storeData && storeData.categories) {
      if (storeData.curatedGroups) {
        const smallBannerGroup: any[] = storeData.curatedGroups.filter((curetedGroup) => curetedGroup.curatedLayout == SAMLL_BANNER && curetedGroup.type == keywords[PRODUCT] && curetedGroup.showOnUi);
        if (smallBannerGroup.length != 0) setSmallBanners(smallBannerGroup[0]);
      }
      let isAnyProductAvl = storeData.categories.filter((cat) => cat.type == keywords[PRODUCT] && cat.active && !cat.hideFromCatalogue);
      if (isAnyProductAvl.length != 0) setIsAnyProductAvailable(true);
      let isAnyServiceAvl = storeData.categories.filter((cat) => cat.type == keywords[SERVICE] && cat.active && !cat.hideFromCatalogue);
      if (isAnyServiceAvl.length != 0) setIsAnyServiceAvailable(true);

      const { configData: { socialLinks } } = storeData;
      if (socialLinks.length != 0) {
        const linksList: any[] = socialLinks.filter((l: any) => l.active);
        let whatsappIndex = linksList.findIndex((l: any) => l.name.includes('whatsapp'));
        if (whatsappIndex != -1) {
          setWhatsappLinkData(linksList[whatsappIndex]);
        }
      }

    }
  }, [storeData]);

  useEffect(() => {
    const init = async () => {
      setCookie('grp', availableGroups[0], {
        path: "/",
        expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
        sameSite: true,
      });

      let memberships: any = [];
      let giftCards: any = [];
      let packages: any = [];

      try {
        if (storeData.configData?.storeConfig?.basicConfig?.membership && membershipDisplay) {
          memberships = await getStoreMembershipData(storeData.tenantId, storeData.storeId);
          memberships = memberships.filter((m: any) => m.active);
        }

        if (storeData.configData?.storeConfig?.basicConfig?.giftCard && giftCardDisplay) {
          giftCards = await getStoreGiftCardData(storeData.tenantId, storeData.storeId);
          giftCards = giftCards.filter((g: any) => g.active);
        }

        if (storeData.configData?.storeConfig?.basicConfig?.packages && packageDisplay) {
          const pkgData: any = await getStorePackageData(storeData.tenantId, storeData.storeId);
          packages = pkgData?.filter(p => (p.id !== CUSTOM_PCKAGEID && p.active)) || [];
        }
        dispatch(updateRedeemablesList({ memberships, giftCards, packages }));

        fetchGuestdetails(userData?.id, { memberships, giftCards, packages });

      } catch (e) {
        console.error(e);
      }
    };

    init();
  }, []);

  useEffect(() => {
    if (availableGroups.length === 1 && activeGroup !== availableGroups[0]) {
      updateGroupStatus(availableGroups[0]);
      changeGroupWiseTheme(availableGroups[0]);
      setCookie('grp', availableGroups[0], {
        path: "/",
        expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)), // Expires after 1hr
        sameSite: true,
      })
    }
  }, [availableGroups])

  useEffect(() => {
    fetchGuestdetails(userData?.id, { ...redeemablesList })

  }, [userData])

  useEffect(() => {

    changeGroupWiseTheme(activeGroup);
    if (availableGroups.length === 1 && activeGroup !== availableGroups[0]) {
      updateGroupStatus(availableGroups[0]);
      changeGroupWiseTheme(availableGroups[0]);
      setCookie('grp', availableGroups[0], {
        path: "/",
        expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)), // Expires after 1hr
        sameSite: true,
      })
      if (storeData && storeData.storeId && availableGroups[0]) {
        if (storeData.categories) {
          // eslint-disable-next-line @typescript-eslint/ban-types
          prepareStoreData(storeData, availableGroups[0]).then((response: {}) => {
            setTimeout(() => {
              dispatch(updateStoreData({ ...response }));
            }, 100);
          })
        }
      }
    } else {
      if (storeData && storeData.storeId && activeGroup) {
        if (storeData.categories) {
          // eslint-disable-next-line @typescript-eslint/ban-types
          prepareStoreData(storeData, activeGroup).then((response: {}) => {
            setTimeout(() => {
              dispatch(updateStoreData({ ...response }));
            }, 100);
          })
        }
      }
    }
  }, [activeGroup])

  const fetchGuestdetails = (guestId, {
    memberships,
    giftCards,
    packages,
  }) => {
    let filteredMemberships = memberships || [];
    let filteredPackages = packages || [];
    if (guestId) {
      getUserByGuestId(storeData?.tenantId, storeData?.storeId, guestId, CAT_HOMEPAGE).then((response: any) => {
        const guestmembership = response.membership;
        const guestPackages = response.packages;
        dispatch(updateGuestMemberships(guestmembership))
        dispatch(updateGuestPackages(guestPackages))

        if (memberships?.length) {
          let newPlans = removeObjRef(memberships)
          if (guestmembership.length) {
            let existingMemberships = (guestmembership?.map((item: any) => item.membershipPlanId)) || []
            newPlans = memberships?.filter((p: any) => (p.active && !existingMemberships?.includes(p.id)))
          }
          filteredMemberships = (newPlans || []).filter((membershipDetails: any) => {
            if (membershipDetails?.txchrgs && membershipDetails.txchrgs?.length !== 0) {
              membershipDetails.taxesTotal = 0;
              membershipDetails.isInclusive = false;
              (membershipDetails.txchrgs).forEach((taxData: any) => {
                delete taxData.id;
                if (membershipDetails.membershipFee) {
                  membershipDetails.taxesTotal += taxData.value;
                }
                if (taxData.isInclusive) {
                  membershipDetails.isInclusive = true;
                }
              });
            } else {
              membershipDetails.txchrgs = [];
              membershipDetails.taxesTotal = 0;
            }
            return membershipDetails;
          });
        }

        if (packages?.length) {
          if (guestPackages.length) {
            let existingPackages = (guestPackages?.map((item: any) => item.packageId)) || []
            filteredPackages = packages?.filter((p: any) => (p.active && !existingPackages?.includes(p.id)))
          }
        }
        dispatch(updateRedeemablesList({ memberships: filteredMemberships, giftCards: giftCards, packages: filteredPackages }));
      }).catch(function (error) {
        console.error("error")
      });
    } else {
      dispatch(updateRedeemablesList({ memberships, giftCards, packages }));
    }
  };

  const changeGroupWiseTheme = (activeGroup) => {
    //theme changes effect
    let color = configData?.storeConfig?.sparkConfig?.color[activeGroup] || '#fea1c2';
    let textColor = configData?.storeConfig?.sparkConfig?.textColor ? configData?.storeConfig?.sparkConfig?.textColor[activeGroup] : '#282828';
    document.documentElement.style.setProperty('--primary-color', hex2rgb(color, ''), 'important');
    document.documentElement.style.setProperty('--primary-text-color', hex2rgb(textColor, ''), 'important');
    document.documentElement.style.setProperty('--primary-color-alpha', hex2rgb(color, 60), 'important');
    document.body.dataset.theme = activeGroup;
    if (baseRouteUrl && windowRef && windowRef().location) {
      const themeMetaElement = document.getElementById("theme-color");
      themeMetaElement?.setAttribute("content", color);
      // updateManifestFile(storeData);
    }
    dispatch(updateGenericImages(getGenericImages(configData, activeGroup)));
    // let defaultWrapper = document.getElementById('default-wrapper');
    // defaultWrapper.style.backgroundImage = `url("/assets/images/${activeGroup}/bg.png")`;
  }

  const onChangeGroup = (value) => {

    dispatch(updateGroupStatus(value));
    dispatch(showSuccess(`${languageData['Filter applied successfully'] ? languageData['Filter applied successfully'] : 'Filter applied successfully'}`))
    setCookie('grp', value, {
      path: "/",
      expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)), // Expires after 1hr
      sameSite: true,
    })
  };

  const onLoginClose = (user) => {
    if (user) setUserData(user);
    setShowUserRegistrationModal(false);
  }

  const getSectionOrder = () => {
    const defaultOrder = {
      services: 1,
      products: 2,
      memberships: 3,
      packages: 4,
      giftcards: 5
    };

    return configData?.storeConfig?.sparkConfig?.homePageIndexing || defaultOrder;
  };

  const getHomeSections = () => {
    const sectionOrder = getSectionOrder();
    const sections = [
      {
        key: 'services',
        order: sectionOrder.services,
        active: configData?.storeConfig?.basicConfig?.services && isAnyServiceAvailable,
        render: () => (
          <>
            <div className="fullwidth">
              <div className="common-section-title common-lr-padd">{configData.serviceListHeading || `${languageData['Our Services'] ? languageData['Our Services'] : 'Our Services'}`}</div>
              <div className="boxlayout category-square-grid">
                <SquareGrid items={storeData.categories} config={{ redirection: true, withShadow: false, from: 'all', type: keywords[SERVICE], activeGroup }} handleClick={() => { }} noImage={SUB_CAT_NO_IMAGE} />
              </div>
            </div>
            {smallBanners &&
              <div className="fullwidth">
                <div className="common-section-title common-lr-padd">{smallBanners.name}</div>
                <div className="midbanner spacing-banner small-banner">
                  <ImageSlider itemsList={smallBanners.curatedCategories} config={{ redirection: true }} no_image={SMALL_SLIDER_NO_IMAGE} />
                </div>
              </div>}
          </>
        )
      },
      {
        key: 'products',
        order: sectionOrder.products,
        active: configData?.storeConfig?.basicConfig?.products && isAnyProductAvailable,
        render: () => (
          <div className="fullwidth">
            {!smallBanners && <div className="common-section-title common-lr-padd">{configData.productListHeading || `${languageData['Our Products'] ? languageData['Our Products'] : 'Our Products'}`}</div>}
            {configData?.showProductCategoryGridView ? <div className="boxlayout category-square-grid product-list-wrap" id="product-list-wrap">
              <SquareGrid items={storeData.categories} config={{ redirection: true, withShadow: false, from: 'all', type: keywords[PRODUCT], activeGroup }} handleClick={() => { }} noImage={SUB_CAT_NO_IMAGE} />
            </div> : <div className="boxlayout product-list-outer product-list-wrap" id="product-list-wrap">
              <ProductsWithCategory categories={storeData.categories} />
            </div>}
          </div>
        )
      },
      {
        key: 'memberships',
        order: sectionOrder.memberships,
        active: configData?.storeConfig?.basicConfig?.membership,
        render: () => (
          <RedeemablesListView fromPage={"home"} type={REDEEMABLES_TYPES.MEMBERSHIPS} userData={userData} setShowUserRegistrationModal={setShowUserRegistrationModal} />
        )
      },
      {
        key: 'packages',
        order: sectionOrder.packages,
        active: configData?.storeConfig?.basicConfig?.packages,
        render: () => (
          <RedeemablesListView fromPage={"home"} type={REDEEMABLES_TYPES.PACKAGES} userData={userData} setShowUserRegistrationModal={setShowUserRegistrationModal} />
        )
      },
      {
        key: 'giftcards',
        order: sectionOrder.giftcards,
        active: configData?.storeConfig?.basicConfig?.giftCard,
        render: () => (
          <RedeemablesListView fromPage={"home"} type={REDEEMABLES_TYPES.GIFTCARDS} userData={userData} setShowUserRegistrationModal={setShowUserRegistrationModal} />
        )
      }
    ];

    return sections.filter(section => section.active).sort((a, b) => a.order - b.order);
  };

  const redirectToCategories = () => {
    let activeCats = storeData.categories.filter((c: any) => c.active && c.type == keywords[SERVICE]);
    let itemUrl = activeCats[0].name.toLowerCase().split(" ").join("-");
    navigateTo(`${itemUrl}-srp`);
  }
  return (
    <>
      <div className="homepageContainer">
        {storeData && storeData.curatedGroups ? <div className="fullwidth">
          <div className="gender-wrap">
            {storeData.sliders?.length != 0 && <div className="herobanner spacing-banner">
              <ImageSlider itemsList={storeData.sliders} config={{}} no_image={BANNER_NO_IMAGE} />
            </div>}
          </div>
          <div>
            {availableGroups?.length > 1 &&
              <div className="gender-wrap-outer">
                {availableGroups.map((group: any) => {
                  return <div key={Math.random()} className={`selmalefemale ${activeGroup == group ? 'active' : ''}`} onClick={() => onChangeGroup(group)}>
                    <div className='name cap-text'>{languageData[group] ? languageData[group] : group}</div>
                  </div>
                })}
              </div>}
            {storeData.curatedGroups?.map((curetedGroup) => {
              return <div className="fullwidth" key={Math.random()}>
                {curetedGroup.showOnUi && curetedGroup.curatedCategories && curetedGroup.curatedCategories?.length != 0 && <>
                  {curetedGroup.name && (curetedGroup.curatedLayout == SAMLL_BANNER ? curetedGroup.type != keywords[PRODUCT] : true) && <div className="common-section-title common-lr-padd">{curetedGroup.languages && curetedGroup.languages[activeLanguage?.languageId]?.name ? curetedGroup.languages[activeLanguage?.languageId]?.name : curetedGroup.name}</div>}

                  {curetedGroup.curatedLayout == CIRCULAR_GRID &&
                    <div className="roundthreelayout">
                      <CircularGrid items={curetedGroup.curatedCategories} config={{}} handleClick={(category) => onClickCategory(category)} />
                    </div>
                  }
                  {curetedGroup.curatedLayout == SAMLL_BANNER && curetedGroup.type != keywords[PRODUCT] &&
                    <div className="midbanner spacing-banner small-banner">
                      <ImageSlider itemsList={curetedGroup.curatedCategories} config={{ redirection: true }} no_image={SMALL_SLIDER_NO_IMAGE} />
                    </div>
                  }
                  {curetedGroup.curatedLayout == HORIZONTAL_SQUARE &&
                    <div className="skilledsection">
                      <HorizontalSquareGrid items={curetedGroup.curatedCategories} config={{}} />
                    </div>
                  }
                  {curetedGroup.curatedLayout == LARGE_BANNER &&
                    <div className="packageoffer spacing-banner">
                      <ImageSlider itemsList={curetedGroup.curatedCategories} config={{ redirection: true }} no_image={LARGE_SLIDER_NO_IMAGE} />
                    </div>
                  }
                  {curetedGroup.curatedLayout == SQUARE_BANNER &&
                    <div className="packageoffer spacing-banner">
                      <ImageSlider itemsList={curetedGroup.curatedCategories} config={{ redirection: true }} no_image={LARGE_SLIDER_NO_IMAGE} />
                    </div>
                  }
                  {curetedGroup.curatedLayout == SQUARE_GRID &&
                    <div className="boxlayout curated-square-grid">
                      <SquareGrid items={curetedGroup.curatedCategories} config={{ redirection: true, withShadow: false, activeGroup }} handleClick={() => { }} noImage={SUB_CAT_NO_IMAGE} />
                    </div>
                  }
                </>}
              </div>
            })}
          </div>
          {storeData.categories &&
            <>
              {getHomeSections().map((section) => (
                <React.Fragment key={section.key}>
                  {section.render()}
                </React.Fragment>
              ))}
            </>
          }
        </div> : null}
      </div>
      {showUserRegistrationModal && <UserRegistrationModal
        fromPage={'PDP'}
        handleResponse={(e) => onLoginClose(e)}
        isApppGrpChangeOnUserGdrChange={showUserRegistrationModal ? true : false}
        open={true}
        heading={'Login to purchase membership'} />}

      {(configData?.storeConfig?.appointmentConfig?.active && currentPage != 'cart' && currentPage != 'checkout' && currentPage != 'appointment' && !cartAppointment.length) ?
        <div className="appointment-wrapper"
          style={{ justifyContent: Boolean(whatsappLinkData) ? 'flex-start' : 'center', paddingLeft: Boolean(whatsappLinkData) ? '30px' : 'unset' }}
          onClick={redirectToCategories}><div className="appointment-button"> {languageData["Book Appointment"] ? languageData["Book Appointment"] : "Book Appointment"} </div>
        </div>
        : <></>

      }
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    storeData: state?.store?.storeData,
    activeGroup: state?.activeGroup,
    storeMetaData: state?.store?.storeMetaData,
  }
}

export default connect(mapStateToProps)(HomePage);
